module.exports = __webpack_public_path__ + "static/media/feature-interview-offer.8efe8b67.png";